import React from 'react';
import { Callout, DocHeading } from './components';

function PageLoaderErrors() {
  return (
    <div>
      <h1 className="text-[2.5rem] leading-[1.1] font-semibold text-white tracking-[-0.02em] mb-3">Loader Errors</h1>
      <p className="text-gray-400 leading-relaxed mb-8">
        These are error codes you may see in the loader window and what they mean.
      </p>

      <DocHeading>Status Message Reference</DocHeading>
      <div className="card overflow-hidden mb-6">
        {[
          { code: '[OK] Success!',               label: 'Injection successful',       desc: 'The bot is running. Keep the loader open — closing it stops the bot.' },
          { code: '[ERROR] Game not running!',   label: 'Game process not found',     desc: 'dro_client64.exe is not running. Start the game and log in to a character first.' },
          { code: '[ERROR] Invalid subscription!',label: 'No active subscription',    desc: 'Subscription expired or frozen. Check Dashboard → Licence & loader.' },
          { code: '[ERROR] Load failed!',        label: 'Payload download failed',    desc: 'Server could not deliver the payload. Check internet connection or wait for maintenance to end.' },
          { code: '[ERROR] Failed!',             label: 'Injection failed',           desc: 'Run as Administrator. Exclude the folder from antivirus / Windows Defender and retry.' },
          { code: 'Error: <message>',            label: 'Login failed',               desc: 'Incorrect username or password. Check your credentials and try again.' },
        ].map(r => (
          <div key={r.code} className="grid grid-cols-[220px_1fr] gap-3 px-5 py-3 border-b border-white/[0.05] last:border-0 text-sm items-start">
            <code className="font-mono text-xs text-brand-300 mt-0.5 break-all">{r.code}</code>
            <div>
              <span className="text-white font-medium">{r.label}</span>
              <span className="text-gray-500"> — {r.desc}</span>
            </div>
          </div>
        ))}
      </div>

      <DocHeading>Loader Won't Open</DocHeading>
      <p className="text-sm text-gray-400 mb-4">
        If the executable does not open at all (no window, no error), try the following in order:
      </p>
      <ol className="space-y-2 text-sm text-gray-400">
        {[
          'Check that the folder is excluded from Windows Defender / antivirus.',
          'Right-click the exe → Properties → Unblock (if the file is blocked by Windows).',
          'Make sure you are running as Administrator.',
          'Try running from a different folder path (avoid spaces and special characters).',
          'Ensure your GPU supports DirectX 11 (any modern GPU does).',
        ].map((s, i) => (
          <li key={i} className="flex items-start gap-2">
            <span className="text-brand-400 font-bold flex-shrink-0">{i + 1}.</span>
            {s}
          </li>
        ))}
      </ol>

      <Callout type="warning">
        If none of the above help, open a support ticket on Discord and describe the exact
        behaviour — include what happens when you double-click the exe and what the loader
        window shows (if anything).
      </Callout>
    </div>
  );
}

export default PageLoaderErrors;
